import React, { useState, useEffect } from "react";
import { Button, Stack, Snackbar } from "@mui/material";
import { useHistory } from "react-router-dom";
import MainUrl from "./Main_URL";

import { BiPlus } from "react-icons/bi";
import StatusCard from "../components/status-card/StatusCard";
import Main from "./Main";
import { setToast } from "../redux/actions/ToastAction";
import { useDispatch, useSelector } from "react-redux";
import Alert from "../components/alert";
import config from "../api/config";

const Home = () => {
  const navigate = useHistory();

  const reducer = useSelector((state) => state.reducer.toast);
  const dispatch = useDispatch();
  // tabs
  const [value, setValue] = useState(0);
  // stats
  const [, setLoading] = useState(false);
  const [stats, setStats] = useState(null);
  useEffect(() => {
    setLoading(true);
    config.get(`/api/statistics/v1/getClickAndSee`).then((data) => {
      setLoading(false);
      setStats(data.data.objectKoinot);
    });
    return () => {
      setLoading(false);
    }

  }, []);

  const toastHandler = () => {
    dispatch(setToast(false, "success", "Успешно Изменено"));
  };
  return (
    <div>
      <Snackbar
        open={reducer.toast}
        autoHideDuration={4000}
        onClose={toastHandler}
      >
        <Alert
          onClose={toastHandler}
          severity={reducer.severity}
          sx={{ width: "100%" }}
        >
          {reducer.content}
        </Alert>
      </Snackbar>
      <Button
        onClick={() => navigate.push(`/advertising`)}
        variant="contained"
        startIcon={<BiPlus />}
        style={{
          background: "var(--second-color)",
          padding: "12px 22px",
          borderRadius: "40px",
          fontWeight: "bold",
        }}
      >
        Добавить Рекламу
      </Button>
      <div className="w-100">
        {" "}
        {stats !== null ? (
          <div className="row my-4">
            <div className="col-lg-3 col-6 ">
              <StatusCard
                count={stats.monthlySee}
                title={"Просмотров в месяц"}
              />
            </div>
            <div className="col-lg-3 col-6 ">
              <StatusCard count={stats.overallSee} title={"Общие просмотры"} />
            </div>
            <div className="col-lg-3 col-6 ">
              <StatusCard count={stats.monthlyClick} title={"Клики в месяц"} />
            </div>
            <div className="col-lg-3 col-6 ">
              <StatusCard
                count={stats.overallClick}
                title={"Общее количество кликов"}
              />
            </div>
          </div>
        ) : (
          <div className="my-3"></div>
        )}
      </div>
      <Stack
        direction="row"
        spacing={2}
        className="col-lg-4 justify-content-start p-0"
      >
        <Button
          variant={value === 0 ? "contained" : "outlined"}
          style={{
            background: value === 0 ? "var(--main-color)" : "",
            fontWeight: value === 0 ? "bold" : "normal",
            padding: "8px 18px",
            borderRadius: "40px",
          }}
          className="col-6"
          onClick={() => setValue(0)}
        >
          Контекстная реклама
        </Button>
        <Button
          variant={value === 1 ? "contained" : "outlined"}
          style={{
            background: value === 1 ? "var(--main-color)" : "",
            fontWeight: value === 1 ? "bold" : "normal",
            padding: "12px 22px",
            borderRadius: "40px",
          }}
          className="col-6"
          onClick={() => setValue(1)}
        >
          Пост реклама
        </Button>
      </Stack>
      {value === 1 ? (
        <Main />
      ) : (
        //
        <MainUrl />
      )}
    </div>
  );
};

export default Home;
